import React from "react";
function Footer() {
  return (
    <footer className="container mx-auto py-2 bottom-0 bg-black">
      <p className="text-sm text-center text-dark-content dark:text-light-content w-full">
        Designed and Coded by
        <span className=" font-bold"> Saurabh</span> with
        <span className="text-gradient font-medium"> Love</span> &
        <span className="text-gradient font-medium"> Coffee</span>
      </p>
    </footer>
  );
}
export default Footer;
